type HeaderPageProps = {
  title: string;
  description: string;
};

export const HeaderPage = (props: HeaderPageProps) => {
  return (
    <div className="flex gap-2 flex-col">
      <span className="text-3xl font-bold text-primary text-[hsl(var(--primary))]">
        {props.title}
      </span>
      <span className="text-[17px] text-gray-500 font-normal">
        {props.description}
      </span>
    </div>
  );
};
